import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/Button';

const MediaGalleryPage = () => {
  const galleryItems = [
    {
      id: 1,
      title: "Jambore Nasional RTD~CL 2024",
      subtitle: "Lembang, 13-15 Sept 2024",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      type: "featured",
      category: "Jambore"
    },
    {
      id: 2,
      title: "Expedisi Gn. Arjuno, 3339 mdpl",
      subtitle: "25-27 Juli 2025",
      image: "/photos/expedisi-gn-arjuno.jpg",
      type: "regular",
      category: "Adventure"
    },
    {
      id: 3,
      title: "Pelatihan Cosmic Voice",
      subtitle: "Malang, 18-20 Okt 2024",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      type: "regular",
      category: "Workshop"
    },
    {
      id: 4,
      title: "Expedisi KM0",
      subtitle: "Bandung - Aceh",
      image: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      type: "regular",
      category: "Adventure"
    },
    {
      id: 5,
      title: "TC Pelatih Nasional RTD 2024",
      subtitle: "Lembang, 29 Nov - 1 Des 2024",
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      type: "regular",
      category: "RTD"
    }
  ];

  const blogArticles = [
    {
      id: 1,
      title: "Memahami Energi Kosmik dalam Kehidupan Sehari-hari",
      excerpt: "Energi kosmik adalah energi kosmik dasar semesta yang mengalir melalui tubuh kita dan dapat mempengaruhi mental kita.",
      image: "https://images.unsplash.com/photo-1518611012118-696072aa579a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "15 Januari 2024",
      readTime: "5 min read",
      category: "SPIRITUAL"
    },
    {
      id: 2,
      title: "5 Teknik Pernafasan untuk Mengurangi Stress",
      excerpt: "Artikel ini membahas berbagai teknik yang dapat Anda praktikkan untuk mengurangi stress dan meningkatkan kualitas hidup Anda.",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "10 Januari 2024",
      readTime: "7 min read",
      category: "KESEHATAN"
    },
    {
      id: 3,
      title: "Membangun Komunitas Spiritual yang Solid",
      excerpt: "Komunitas spiritual RTDCL memiliki peran penting dalam memberikan dukungan dan pengembangan spiritual bagi para anggotanya.",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "5 Januari 2024",
      readTime: "6 min read",
      category: "KOMUNITAS"
    }
  ];

  return (
    <div className="font-sans">
      <Header activePage="media" />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-indigo-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Media & Gallery
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Dokumentasi kegiatan dan momen-momen berharga dalam perjalanan spiritual komunitas RTD~CL
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Featured Image - Large */}
            <div className="lg:col-span-2">
              <div className="relative group overflow-hidden rounded-lg shadow-lg h-96 lg:h-full">
                <img 
                  src={galleryItems[0].image}
                  alt={galleryItems[0].title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute bottom-6 left-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">{galleryItems[0].title}</h3>
                  <p className="text-sm opacity-90">{galleryItems[0].subtitle}</p>
                </div>
              </div>
            </div>

            {/* Small Images Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
              {galleryItems.slice(1).map((item) => (
                <div key={item.id} className="relative group overflow-hidden rounded-lg shadow-lg h-44">
                  <img 
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 left-3 text-white">
                    <h4 className="text-sm font-bold mb-1">{item.title}</h4>
                    <p className="text-xs opacity-90">{item.subtitle}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Blog & Articles Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-4">Blog & Artikel Terbaru</h2>
              <p className="text-gray-600">
                Baca artikel inspiratif tentang pengembangan diri dan spiritualitas
              </p>
            </div>
            <Button variant="outline">Lihat Semua Artikel</Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogArticles.map((article) => (
              <div key={article.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="relative">
                  <img 
                    src={article.image}
                    alt={article.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-4 left-4">
                    <span className={`px-3 py-1 text-xs font-semibold rounded-full text-white ${
                      article.category === 'SPIRITUAL' ? 'bg-purple-500' :
                      article.category === 'KESEHATAN' ? 'bg-green-500' :
                      'bg-blue-500'
                    }`}>
                      {article.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="flex justify-between items-center text-sm text-gray-500">
                    <span>{article.date}</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MediaGalleryPage;
